module.exports = __webpack_public_path__ + "img/MONITOR.9689758e.gif";